package com.eladfinish.bible.contest.screens.chapterComplete.features.shuffle

import androidx.compose.ui.text.AnnotatedString
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList
import kotlin.random.Random

class BuildShuffledVersesUseCase(
    private val random: Random,
) {

    operator fun invoke(
        partitionedChapter: List<List<List<String>>>,
        appendColonToSeyfa: Boolean = true,
    ): ImmutableList<RevealCardData> {

        val verses: List<RevealCardData> = partitionedChapter.map { verseParts ->
            val otPasuk = verseParts[0][0]

            val partsCount = verseParts.size - 1 // exclude otPasuk bucket

            val reyshaWords = verseParts.getOrNull(1).orEmpty()

            // 2 parts: seyfa is index 2
            // 3 parts: seyfa is index 2 + index 3 (middle + last)
            val seyfaWords: List<String> =
                if (partsCount >= 3) {
                    verseParts.getOrNull(2).orEmpty() +
                            verseParts.getOrNull(3).orEmpty()
                } else {
                    verseParts.getOrNull(2).orEmpty()
                }

            val reysha = normalizeMakafSpacing(
                text = reyshaWords.joinToString(separator = " "),
            )

            val seyfaBase = normalizeMakafSpacing(
                text = seyfaWords.joinToString(separator = " "),
            )

            val seyfa = if (appendColonToSeyfa) {
                seyfaBase.trimEnd() + StringConstants.COLON_SPLITTER
            } else {
                seyfaBase.trimEnd()
            }

            RevealCardData(
                otPasuk = otPasuk,
                reysha = AnnotatedString(reysha),
                seyfa = AnnotatedString(seyfa),
            )
        }

        return verses
            .shuffled(random = random)
            .toImmutableList()
    }

    /**
     * Removes unwanted space after Hebrew makaf (־)
     * Example:
     * "וַיְהִי־ לִי" -> "וַיְהִי־לִי"
     */
    private fun normalizeMakafSpacing(
        text: String,
    ): String {
        return text.replace(
            regex = "$MAKAF ".toRegex(),
            replacement = MAKAF.toString(),
        )
    }
}
